import {
    Component,
    createEffect,
    createSignal,
    onCleanup,
    onMount,
    Show,
} from 'solid-js'

import { SearchIcon, SettingIcon } from 'icons/account'
import { CloseIcon } from 'icons/login'
import { MapFillIcon } from 'icons/navbar'
import { default_confetties } from 'shared'
import { JSX } from 'solid-js/jsx-runtime'
import { USER_READ_UPDATES_ID } from 'store/dbLabels'
import { loadingState } from 'store/user'
import { showAddHome } from './addHome'
import { IsMobile } from './helpers'
import './style/updatenotif.scss'

const UPDATE_ID = 'PREFERENCE'

export const [showUpdateNotif, setShowUpdateNotif] = createSignal(false)

const UpdateNotif: Component = () => {
    const THRESHOLD = 80

    onMount(() => {
        let read_id = localStorage.getItem(USER_READ_UPDATES_ID)

        if (read_id && read_id == UPDATE_ID) return

        setShowUpdateNotif(true)
    })

    createEffect(() => {
        if (loadingState.ended && showUpdateNotif() && !showAddHome()) {
            default_confetties()
        }
    })

    const close = (clear = true) => {
        if (avoid_closing) return

        if (clear) {
            localStorage.setItem(USER_READ_UPDATES_ID, UPDATE_ID)
        }

        setShowUpdateNotif(false)
    }
    const closeSmoothly = () => {
        // if (!isMobile()) return close()

        wrapperRef.classList.toggle('hide', true)

        wrapperRef.style.animation =
            'update-notif-wrapper-close-anim 0.3s ease forwards'

        interval = setTimeout(() => {
            close()
        }, 200)
    }

    onCleanup(() => {
        if (timer) clearTimeout(timer)

        interval && clearInterval(interval)
        close(false)
    })

    let timer: NodeJS.Timeout | null = null
    let wrapperRef: HTMLElement
    let childRef: HTMLElement

    let interval: ReturnType<typeof setTimeout>
    let startX = 0
    let startY = 0
    let axisLock: 'x' | 'y' | null = null
    let disable = false
    let scrolled = false

    let avoid_closing = false

    const onTouchStart = (e: any) => {
        if (childRef.scrollTop > 0) return (scrolled = true)
        scrolled = false

        startX = e.touches[0]!.clientX
        startY = e.touches[0]!.clientY
        axisLock = null

        e.currentTarget.style.transform = 'translateY(0%)'
        e.currentTarget.style.opacity = '1'
        e.currentTarget.style.animation = 'none'
        e.currentTarget.style.transition = 'none'

        return
    }
    const onTouchMove = (e: any) => {
        // e.preventDefault()

        if (scrolled) return

        const deltaX = e.touches[0]!.clientX - startX
        const deltaY = e.touches[0]!.clientY - startY

        if (!axisLock) {
            axisLock = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y'
        }

        if (axisLock == 'x') return (disable = true)

        if (axisLock == 'y' && e.touches[0]!.clientY < startY)
            return (disable = true)

        disable = false

        const el = e.currentTarget as HTMLElement
        const moveY = axisLock === 'y' ? deltaY : 0
        el.style.transform = `translate(0, ${moveY}px)`

        const dist = Math.abs(moveY)
        const opacity = Math.max(0, 1 - dist / 150)
        el.style.opacity = `${opacity}`

        return
    }
    const onTouchEnd = (e: any) => {
        if (scrolled) return

        const el = e.currentTarget as HTMLElement

        if (disable) return

        const deltaX = e.changedTouches[0]!.clientX - startX
        const deltaY = e.changedTouches[0]!.clientY - startY

        const dist = axisLock === 'x' ? deltaX : deltaY

        el.style.animation = 'none'

        if (Math.abs(dist) > THRESHOLD) {
            el.style.transition = 'transform 0.3s ease, opacity 0.3s ease'
            el.style.opacity = '0'

            close()

            interval = setTimeout(() => {
                wrapperRef.removeAttribute('style')
            }, 200)
        } else {
            el.style.transition = 'transform 0.3s ease, opacity 0.3s ease'
            el.style.transform = 'translate(0, 0)'
            el.style.opacity = '1'
        }
    }

    const Mascot: Component = () => (
        <div class='mascot-container'>
            <img
                src='/public/svgs/mascot/advertising.svg'
                loading='lazy'
                decoding='async'
            />
            <div class='stars'>
                <div class='star'></div>
                <div class='star'></div>
                <div class='star'></div>
                <div class='star'></div>
                <div class='star'></div>
                <div class='star'></div>
                <div class='star'></div>
            </div>
        </div>
    )

    const Titles: Component = () => {
        return (
            <div class='titles'>
                <div class='main title_hero2'>آپدیت جدید داریم!</div>
                <div class='sub title_small'>
                    از الان میتونی از این امکانات جدید استفاده کنی
                </div>
            </div>
        )
    }

    const UpdateDetails: Component = () => {
        interface UpdateRowProps {
            Icon: JSX.Element
            title: string
            desc?: string
            class?: string
        }
        const UpdateRow: Component<UpdateRowProps> = R => {
            return (
                <div class='update-row' classList={{ [R.class || '']: true }}>
                    <div class='icon'>{R.Icon}</div>
                    <div class='holders'>
                        <div class='main title'>{R.title}</div>
                        <Show when={R.desc}>
                            <div class='sub title_smaller'>{R.desc}</div>
                        </Show>
                    </div>
                </div>
            )
        }
        return (
            <div class='update-details'>
                <UpdateRow
                    Icon={<MapFillIcon />}
                    title='جستجو محله‌ها'
                    desc='از بخش جستجو میتونی محله ای که میخوای داخلش بگردی رو انتخاب کنی'
                    class='discount'
                />
                <UpdateRow
                    Icon={<SearchIcon />}
                    class='search'
                    title='جستجو با سلیقت'
                    desc='بعد از اینکه چندتا جارو نگاه کنی، گوجه سلیقت رو میفهمه و بهت پیشنهاد های خفن میده!'
                />
                <UpdateRow
                    class='setting'
                    Icon={<SettingIcon />}
                    title='درست کردن باگ هایی که گزارش داده بودین'
                    // desc=''
                />
            </div>
        )
    }

    const Cta: Component = () => {
        return (
            <div class='update-notif-cta'>
                <button
                    type='button'
                    onclick={closeSmoothly}
                    class='update-cta title_small'
                >
                    بزن بریم!
                </button>
            </div>
        )
    }

    return (
        <Show when={showUpdateNotif()}>
            <div class='update-notif-cmp' onclick={closeSmoothly}>
                <div
                    onclick={e => e.stopPropagation()}
                    ontouchstart={onTouchStart}
                    ontouchmove={onTouchMove}
                    ontouchend={onTouchEnd}
                    class='update-notif-wrapper'
                    ref={e => (wrapperRef = e)}
                >
                    <IsMobile not>
                        <button
                            type='button'
                            class='close icon'
                            onclick={() => close()}
                        >
                            <CloseIcon />
                        </button>
                    </IsMobile>
                    <IsMobile>
                        <div
                            class='draggable'
                            role='button'
                            onclick={() => {
                                wrapperRef.removeAttribute('style')
                                wrapperRef.classList.toggle('hide', true)

                                interval = setTimeout(() => {
                                    close()
                                }, 200)
                            }}
                        ></div>
                    </IsMobile>

                    <div
                        class='update-notif-container'
                        ref={e => (childRef = e)}
                    >
                        <Mascot />

                        <Titles />

                        <UpdateDetails />

                        <Cta />
                    </div>
                </div>
            </div>
        </Show>
    )
}

export default UpdateNotif
